import script from "./StartZusatzNew.vue?vue&type=script&setup=true&lang=js"
export * from "./StartZusatzNew.vue?vue&type=script&setup=true&lang=js"

import "./StartZusatzNew.vue?vue&type=style&index=0&id=3a0b5fb7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a0b5fb7"]])

export default __exports__